type Props = {
  count: number
  singular: string
  plural: string
}

const Pluralize = ({ count, singular, plural }: Props): JSX.Element => {
  return <span>{count === 1 ? singular : plural}</span>
}

export default Pluralize
